import React from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs, Link, Typography } from '@mui/material';

interface BreadcrumbItem {
  text: string;
  onClick?: () => void;
  isLink?: boolean;
}

interface DefaultBreadcrumbsProps {
  items: BreadcrumbItem[];
}

const DefaultBreadcrumbs: React.FC<DefaultBreadcrumbsProps> = ({ items }) => {
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize='small' />}
      aria-label='breadcrumb'
      sx={{ pt: 1, pb: 1 }}
    >
      {items.map((item, index) =>
        item.isLink ? (
          <Link
            key={index}
            underline='hover'
            sx={{ cursor: 'pointer', fontWeight: 'bolder' }}
            color={(theme) => theme.palette.primary.main}
            onClick={item.onClick}
          >
            {item.text}
          </Link>
        ) : (
          <Typography key={index} sx={{ fontWeight: 'bolder' }}>
            {item.text}
          </Typography>
        ),
      )}
    </Breadcrumbs>
  );
};

export default DefaultBreadcrumbs;
